var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrowSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47CEAC"
    },
    d: "M0,256.006C0,397.402,114.606,512.004,255.996,512C397.394,512.004,512,397.402,512,256.006 C512.009,114.61,397.394,0,255.996,0C114.606,0,0,114.614,0,256.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36BB9A"
    },
    d: "M501.432,328.826L260.998,88.393c-2.762-2.762-7.235-2.762-9.998,0L109.603,229.792 c-2.762,2.762-2.762,7.235,0,9.997c0.29,0.29,0.657,0.423,0.98,0.652c0.228,0.323,0.362,0.691,0.652,0.98 c0.29,0.289,137.505,137.341,137.695,137.494v39.693c0,2.375,1.248,4.374,3.045,5.657c0.458,0.641,76.069,76.252,76.709,76.709 c0.109,0.153,0.27,0.247,0.388,0.388C411.771,476.772,476.923,411.558,501.432,328.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M402.397,229.792L260.998,88.393c-2.762-2.762-7.235-2.762-9.997,0L109.603,229.792 c-2.762,2.762-2.762,7.235,0,9.997s7.235,2.762,9.997,0l129.33-129.33v308.149c0,3.904,3.166,7.07,7.07,7.07 c3.904,0,7.07-3.166,7.07-7.07V110.459l129.33,129.33c1.381,1.381,3.189,2.071,4.998,2.071s3.618-0.69,4.998-2.071 C405.159,237.027,405.159,232.554,402.397,229.792z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowSvgrepoCom);
export default __webpack_public_path__ + "static/media/up-arrow-svgrepo-com.70846b586740a18c646683dcff561e32.svg";
export { ForwardRef as ReactComponent };